import { render } from "./PeritosEstados.vue?vue&type=template&id=db0c73a6"
const script = {}

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__